import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OldRetiredContent, RetiredContent } from "JS/Models/RetiredContent";
export interface RetiredContentState {
    retiredContent: OldRetiredContent;
    retiredAudios?: RetiredContent;
    retiredVideos?: RetiredContent;
    isRetAudioUpdateRequired?: boolean;
    isRetVideoUpdateRequired?: boolean;
}

const initialState: RetiredContentState = {
    retiredContent: {
        MP3: [],
        Video: [],
        GiftProsMP3: [],
        GiftMP3: [],
        GiftVideo: [],
        GiftProsVideo: [],
        Course: [],
        GiftCourse: [],
    },
    retiredAudios: [],
    retiredVideos: [],
    isRetAudioUpdateRequired: false,
    isRetVideoUpdateRequired: false,
};

export const retiredContentStateSlice = createSlice({
    name: "retiredContentState",
    initialState,
    reducers: {
        setRetiredAudios: (state, data: PayloadAction<RetiredContent>) => {
            state = {
                retiredContent: { ...initialState.retiredContent },
                retiredAudios: data.payload,
                isRetAudioUpdateRequired: false,
            };
            return state;
        },

        setRetiredVideos: (state, data: PayloadAction<RetiredContent>) => {
            state = {
                retiredContent: { ...initialState.retiredContent },
                retiredVideos: data.payload,
                isRetVideoUpdateRequired: false,
            };
            return state;
        },

        setRetAudioContentUpdateRequired: (
            state,
            data: PayloadAction<boolean>,
        ) => {
            return {
                ...state,
                isRetAudioUpdateRequired: data.payload,
            };
        },

        setRetVideoContentUpdateRequired: (
            state,
            data: PayloadAction<boolean>,
        ) => {
            return {
                ...state,
                isRetVideoUpdateRequired: data.payload,
            };
        },

        setRetContentUpdateRequired: (state) => {
            state = {
                retiredContent: { ...initialState.retiredContent },
                retiredAudios: state.retiredAudios,
                retiredVideos: state.retiredVideos,
                isRetAudioUpdateRequired: true,
                isRetVideoUpdateRequired: true,
            };
            return state;
        },

        resetRetiredContentState: (state) => {
            return initialState;
        },
    },
});

export const {
    setRetiredAudios,
    setRetiredVideos,
    setRetContentUpdateRequired,
    setRetAudioContentUpdateRequired,
    setRetVideoContentUpdateRequired,
    resetRetiredContentState,
} = retiredContentStateSlice.actions;
